export const OBSERVE_WEB_MAINTENANCE_MODE = "observe-web-maintenance-mode";
